import React from 'react';
import './loaders.css';

const Loaders = () => {
  return (
    <div className="loading">
      <div className="spinner">
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
      </div>
    </div>
  );
};

export default Loaders;
